<ion-header>
	<app-order-page-toolbar
		[hideElements]="loading"
		(backClick)="backOrDismiss()"
		(close)="dismiss()"
		[preorderType]="isOverviewPage ? null : order.preorder.type"
		[title]="(isOverviewPage ? 'checkout_modal.overview' : 'checkout_modal.header') | translate"
		role="banner"
		aria-label="Order page navigation"
	>
	</app-order-page-toolbar>
</ion-header>
<ion-content role="main" [attr.aria-label]="(isOverviewPage ? 'checkout_modal.overview' : 'checkout_modal.header') | translate">
	<ng-container *ngIf="order && venue">
		<swiper-container
			#swiperCheckout
			swiperElement
			[config]="slideOptions"
			[formGroup]="orderForm"
			[allowTouchMove]="false"
			role="tabpanel"
			aria-label="Checkout steps"
		>
			<!-- Step 1: Personal Information Form -->
			<swiper-slide role="tabpanel" aria-labelledby="personal-info-heading">
				<h2 id="personal-info-heading" class="sr-only">Personal Information</h2>
				<ion-row class="form-row">
					<ion-col class="ion-no-padding">
						<div class="form-card" role="form" aria-labelledby="personal-info-heading">
							<div class="container">
								<ion-label
									class="stacked"
									[class.label-error]="isValid('name') || isValidByPattern('name')"
									for="name-input"
									>{{ 'checkout_modal.name' | translate }}*</ion-label
								>
								<ion-item
									class="ion-invalid"
									[class.ion-info]="!isValid('name') && isValidByPattern('name')"
									[attr.aria-invalid]="isValid('name') || isValidByPattern('name')"
									[attr.aria-describedby]="isValid('name') || isValidByPattern('name') ? 'name-error' : null"
								>
									<ion-input
										formControlName="name"
										name="name"
										id="name-input"
										aria-required="true"
										[attr.aria-describedby]="isValid('name') || isValidByPattern('name') ? 'name-error' : null"
									></ion-input>
								</ion-item>
								<div class="error_container" id="name-error" role="alert" aria-live="polite">
									<ion-note class="input-error" [class.visible]="isValid('name')" [attr.aria-hidden]="!isValid('name')">{{
										'checkout_modal.validation.required' | translate
									}}</ion-note>
									<ion-note
										class="input_info"
										[class.visible]="!isValid('name') && isValidByPattern('name')"
										[attr.aria-hidden]="!(!isValid('name') && isValidByPattern('name'))"
										>{{ 'checkout_modal.validation.name' | translate }}</ion-note
									>
								</div>
							</div>

							<div class="container">
								<ion-label
									class="stacked"
									[class.label-error]="isValid('email') || isValidByPattern('email')"
									for="email-input"
									>{{ 'checkout_modal.email' | translate }}*</ion-label
								>
								<ion-item
									class="ion-invalid"
									[class.ion-info]="!isValid('email') && isValidByPattern('email')"
									[attr.aria-invalid]="isValid('email') || isValidByPattern('email')"
									[attr.aria-describedby]="isValid('email') || isValidByPattern('email') ? 'email-error' : null"
								>
									<ion-input
										formControlName="email"
										name="email"
										id="email-input"
										type="email"
										aria-required="true"
										[attr.aria-describedby]="isValid('email') || isValidByPattern('email') ? 'email-error' : null"
									></ion-input>
								</ion-item>
								<div class="error_container" id="email-error" role="alert" aria-live="polite">
									<ion-note
										class="input-error"
										[class.visible]="isValid('email')"
										slot="error"
										[attr.aria-hidden]="!isValid('email')"
										>{{ 'checkout_modal.validation.required' | translate }}</ion-note
									>
									<ion-note
										class="input_info"
										[class.visible]="!isValid('email') && isValidByPattern('email')"
										slot="error"
										[attr.aria-hidden]="!(!isValid('email') && isValidByPattern('email'))"
										>{{ 'checkout_modal.validation.email' | translate }}</ion-note
									>
								</div>
							</div>

							<div class="custom_phone">
								<ion-label class="stacked" for="phone-input">{{ 'checkout_modal.phone' | translate }}*</ion-label>
								<ion-item
									class="ion-invalid item_input"
									[class.ion-info]="!isValid('phone') && isValidByPattern('phone')"
									[attr.aria-invalid]="isValid('phone')"
									[attr.aria-describedby]="isValid('phone') ? 'phone-error' : null"
								>
									<app-input-phone-with-county-code
										formControlName="phone"
										id="phone-input"
										aria-required="true"
										[attr.aria-describedby]="isValid('phone') ? 'phone-error' : null"
									></app-input-phone-with-county-code>
								</ion-item>
								<div class="error_container" id="phone-error" role="alert" aria-live="polite">
									<ion-note
										class="input-error"
										[class.visible]="isValid('phone')"
										slot="error"
										[attr.aria-hidden]="!isValid('phone')"
										>{{ 'sign_up.validation.required' | translate }}</ion-note
									>
									<ion-note
										class="input_info"
										[class.visible]="
											!isValid('phone') && getErrorsForm('phone')?.invalidPhone && orderForm.get('phone')?.dirty
										"
										slot="error"
										[attr.aria-hidden]="
											!(!isValid('phone') && getErrorsForm('phone')?.invalidPhone && orderForm.get('phone')?.dirty)
										"
										>{{ 'errors.phone' | translate }}</ion-note
									>
								</div>
							</div>

							<!-- Note field for delivery -->
							<ng-container *ngIf="order.preorder.type === pt.DELIVERY">
								<div class="container">
									<ion-label for="note-input-delivery">{{ 'checkout_modal.note' | translate }}</ion-label>
									<ion-item lines="none">
										<ion-input formControlName="note" name="note" id="note-input-delivery"></ion-input>
									</ion-item>
								</div>
							</ng-container>
							<ng-container *ngIf="order.preorder.type !== pt.DELIVERY">
								<div class="container margin-top-value">
									<ion-label for="note-input-other">{{ 'checkout_modal.note' | translate }}</ion-label>
									<ion-item lines="none">
										<ion-input formControlName="note" name="note" id="note-input-other"></ion-input>
									</ion-item>
								</div>
							</ng-container>

							<!-- Address fields for delivery -->
							<div
								class="input_group-1"
								*ngIf="order.preorder.type === pt.DELIVERY"
								role="group"
								aria-labelledby="address-heading"
							>
								<h3 id="address-heading" class="sr-only">Address Information</h3>
								<div class="container input_group-1--1">
									<ion-label
										[class.input-error]="streetError"
										[class.ion-hide]="order.preorder.type !== pt.DELIVERY"
										for="street-input"
									>
										{{ 'checkout_modal.street' | translate }}
									</ion-label>
									<ion-item
										[class.ion-hide]="order.preorder.type !== pt.DELIVERY"
										lines="none"
										[attr.aria-describedby]="streetError ? 'street-error' : null"
									>
										<ion-input
											formControlName="street"
											name="street"
											readonly
											id="street-input"
											[attr.aria-describedby]="streetError ? 'street-error' : null"
										></ion-input>
									</ion-item>
									<div *ngIf="streetNumberError" class="error-text" id="street-error" role="alert">
										{{ streetNumberError }}
									</div>
								</div>
								<div class="container input_group-1--2">
									<ion-label
										[class.input-error]="streetNumberError"
										[class.ion-hide]="order.preorder.type !== pt.DELIVERY"
										for="number-input"
										>{{ 'checkout_modal.number' | translate }}</ion-label
									>
									<ion-item class="checkout-input" lines="full">
										<ion-input
											formControlName="number"
											name="number"
											readonly
											id="number-input"
											aria-describedby="lock-description"
										></ion-input>
										<ion-icon class="lock-icon" slot="end" src="/assets/icon/lock.svg" aria-hidden="true"> </ion-icon>
									</ion-item>
									<span id="lock-description" class="sr-only">This field is locked and cannot be edited</span>
								</div>
							</div>

							<div
								class="input_group-2"
								*ngIf="order.preorder.type === pt.DELIVERY"
								role="group"
								aria-labelledby="postal-city-heading"
							>
								<h3 id="postal-city-heading" class="sr-only">Postal Code and City</h3>
								<div class="container input_group-2--1">
									<ion-label [class.input-error]="postalCodeError" for="postal-code-input">{{
										'checkout_modal.postal_code' | translate
									}}</ion-label>
									<ion-item
										class="checkout-input"
										lines="full"
										[attr.aria-describedby]="postalCodeError ? 'postal-code-error' : null"
									>
										<ion-input
											formControlName="postalCode"
											[readonly]="hadPostalCode"
											name="postalCode"
											id="postal-code-input"
											[attr.aria-describedby]="postalCodeError ? 'postal-code-error' : null"
										>
										</ion-input>
										<ion-icon
											class="lock-icon"
											slot="end"
											src="/assets/icon/lock.svg"
											aria-hidden="true"
											*ngIf="hadPostalCode"
										>
										</ion-icon>
									</ion-item>
									<div *ngIf="postalCodeError" class="error-text" id="postal-code-error" role="alert">
										{{ postalCodeError }}
									</div>
								</div>
								<div class="container input_group-2--2">
									<ion-label for="city-input">{{ 'checkout_modal.city' | translate }} </ion-label>
									<ion-item class="checkout-input disabled" lines="none">
										<ion-input
											formControlName="city"
											name="city"
											readonly
											id="city-input"
											aria-describedby="city-readonly-description"
										></ion-input>
									</ion-item>
									<span id="city-readonly-description" class="sr-only"
										>City field is automatically filled and readonly</span
									>
								</div>
							</div>
						</div>
					</ion-col>
				</ion-row>

				<!-- Time slot selection -->
				<ion-row class="slots-row" *ngIf="order.preorder.type !== pt.FOOD_SPOT" role="group" aria-labelledby="time-slot-heading">
					<h2 [class.input-error]="orderAtError" class="order-at-header" id="time-slot-heading">
						{{ 'checkout_modal.' + order.preorder.type + '_time' | translate }}
					</h2>
					<div class="selection_container" [attr.aria-describedby]="orderAtError ? 'time-slot-error' : null">
						<app-select-date-formcontrol
							formControlName="orderAt"
							[slot]="order.orderAt"
							[slots]="slots"
							[attr.aria-describedby]="orderAtError ? 'time-slot-error' : null"
							aria-required="true"
						>
						</app-select-date-formcontrol>
					</div>
					<div *ngIf="orderAtError" id="time-slot-error" class="error-text" role="alert">
						{{ orderAtError }}
					</div>

					<ng-container *ngIf="order.preorder.type === pt.DELIVERY && checkDelivery()">
						<div class="btn_wrapper">
							<p>
								{{ 'driver_exist_hint' | translate }}
							</p>
						</div>
						<div class="btn_wrapper" *ngIf="slots?.length > 0 && !loadQuote">
							<ion-button
								class="check_btn"
								(click)="selectTimeSlot(getFormControlValue('orderAt'))"
								[attr.aria-label]="'driver_exist_btn' | translate"
								>{{ 'driver_exist_btn' | translate }}</ion-button
							>
						</div>
						<div class="btn_wrapper" *ngIf="loadQuote" role="status" aria-live="polite">
							<ion-spinner name="crescent" aria-label="Loading driver availability"></ion-spinner>
						</div>
					</ng-container>
				</ion-row>
			</swiper-slide>

			<!-- Step 2: Overview -->
			<swiper-slide role="tabpanel" aria-labelledby="overview-heading">
				<h2 id="overview-heading" class="sr-only">Order Overview</h2>
				<ion-row class="main-overview-row">
					<ion-col class="ion-no-padding">
						<!-- Personal Data Card -->
						<ion-card role="region" aria-labelledby="personal-data-heading">
							<ion-card-header>
								<ion-row class="ion-justify-content-between">
									<ion-col class="ion-no-padding ion-align-self-center">
										<ion-card-title id="personal-data-heading">
											{{ 'checkout_modal.personal_data' | translate }}
										</ion-card-title>
									</ion-col>
									<ion-icon
										(click)="editPersonalData()"
										class="ion-no-margin icon-edit"
										color="primary"
										src="../../../assets/dean_and_david/edit_article.svg"
										role="button"
										tabindex="0"
										[attr.aria-label]="'Edit personal data'"
									></ion-icon>
								</ion-row>
							</ion-card-header>
							<ion-card-content>
								<ion-row>
									<ion-col class="ion-no-padding">
										<dl>
											<div class="info-row">
												<dt class="left-col">{{ 'checkout_modal.order_type' | translate }}</dt>
												<dd>
													<ion-chip *ngIf="order.preorder?.type">
														<ion-label>
															{{ 'preorder_type.' + order.preorder?.type | translate }}
														</ion-label>
													</ion-chip>
												</dd>
											</div>

											<div class="info-row" *ngIf="getFormControlValue('orderAt')">
												<dt class="left-col">
													{{ 'checkout_modal.overview_' + order.preorder.type + '_date' | translate }}
												</dt>
												<dd *ngIf="getFormControlValue('orderAt')?.format" class="right-col">
													{{ getFormControlValue('orderAt').format('DD.MM.yyyy') }}
												</dd>
												<dd *ngIf="!getFormControlValue('orderAt')" class="right-col">
													{{ 'checkout_modal.first_slot' | translate }}
												</dd>
											</div>

											<div class="info-row">
												<dt class="left-col">
													{{ 'checkout_modal.overview_' + order.preorder.type + '_time' | translate }}
												</dt>
												<dd *ngIf="getFormControlValue('orderAt')?.format" class="right-col">
													{{ getFormControlValue('orderAt').format('HH:mm') }}
												</dd>
												<dd *ngIf="!getFormControlValue('orderAt')" class="right-col">
													{{ 'checkout_modal.first_slot' | translate }}
												</dd>
											</div>

											<div class="info-row">
												<dt class="left-col">{{ 'checkout_modal.name' | translate }}</dt>
												<dd class="right-col">{{ getFormControlValue('name') }}</dd>
											</div>

											<div class="info-row">
												<dt class="left-col">{{ 'checkout_modal.email' | translate }}</dt>
												<dd class="right-col">{{ getFormControlValue('email') }}</dd>
											</div>

											<div class="info-row" *ngIf="getFormControlValue('phone')?.phone">
												<dt class="left-col">{{ 'checkout_modal.phone' | translate }}</dt>
												<dd class="right-col">
													{{ getFormControlValue('phone')?.country }} {{ getFormControlValue('phone')?.phone }}
												</dd>
											</div>

											<div class="info-row" *ngIf="order.preorder.street === pt.DELIVERY">
												<dt class="left-col">{{ 'checkout_modal.street' | translate }}</dt>
												<dd class="right-col">
													<ng-container
														*ngIf="order.preorder.street || order.preorder.number || order.preorder.postalCode"
													>
														{{ order.preorder.street }} {{ order.preorder.number }}, <br />{{
															order.preorder.postalCode
														}}
													</ng-container>
													<ng-container *ngIf="order.preorder.city"> {{ order.preorder.city }}, </ng-container>
													<ng-container *ngIf="order.preorder?.country">
														{{ (order.preorder?.country ?? '').toUpperCase() }}
													</ng-container>
												</dd>
											</div>
										</dl>
									</ion-col>
								</ion-row>
							</ion-card-content>
						</ion-card>

						<!-- Cart Card -->
						<ion-card role="region" aria-labelledby="cart-heading">
							<ion-card-header>
								<ion-row>
									<ion-col class="ion-no-padding ion-align-self-center">
										<ion-card-title id="cart-heading">
											{{ 'checkout_modal.your_cart' | translate }}
										</ion-card-title>
									</ion-col>
									<ion-icon
										(click)="dismiss()"
										color="primary "
										class="ion-no-margin icon-edit"
										src="../../../assets/dean_and_david/edit_article.svg"
										role="button"
										tabindex="0"
										[attr.aria-label]="'Edit cart'"
									></ion-icon>
								</ion-row>
							</ion-card-header>
							<ion-card-content>
								<ion-row class="articles-row">
									<ion-col class="ion-no-padding">
										<ul role="list" aria-label="Cart items">
											@for (oa of mappedOrderArticlesValue; track $index) {
												<li class="article-row" role="listitem">
													<ion-row>
														<ion-col size="8" class="name-col">
															<ion-icon
																src="../../../assets/dean_and_david/item-checkout.svg"
																aria-hidden="true"
															></ion-icon>
															<h3>{{ oa.quantity }}x {{ oa.article.name | langString }}</h3>
														</ion-col>
														<ion-col size="4" class="article-price">
															{{
																numberToCurrency(
																	orderUtils.totalPrice(oa, order.type, order.preorder.type),
																	order.currency
																)
															}}
														</ion-col>
														<ion-col size="12" *ngIf="oa.groups && oa.groups.length > 0">
															<ul role="list" aria-label="Item options">
																<ng-container *ngFor="let group of oa.groups">
																	<li
																		*ngIf="!hiddenInCart(group.article)"
																		class="option-name"
																		role="listitem"
																	>
																		<ion-col class="ion-no-padding" size="12">
																			{{ group.article.name | langString }}

																			<span *ngIf="priceOfOption(oa, group) > 0">
																				+
																				{{
																					numberToCurrency(
																						priceOfOption(oa, group),
																						order.currency
																					)
																				}}
																			</span>
																		</ion-col>
																	</li>
																</ng-container>
															</ul>
															<ion-row class="note" *ngIf="oa.note && oa.note.length > 0">
																<span>Notiz: {{ oa.note }}</span>
															</ion-row>
														</ion-col>
													</ion-row>
												</li>
											}
										</ul>
									</ion-col>
								</ion-row>
							</ion-card-content>
						</ion-card>

						<div *ngIf="paperBagGroup && paperBag" class="paper-card">
							<app-order-list
								[hideRemoveItem]="true"
								[cardTitle]="'checkout_modal.paper_bag_title' | translate"
								[showSinglePrice]="true"
								[venue]="venue"
								(action)="onAction(paperBagGroup, $event)"
								[articleGroup]="paperBagGroup"
								[editable]="true"
								[order]="order"
							></app-order-list>
						</div>
					</ion-col>
				</ion-row>
			</swiper-slide>
		</swiper-container>
	</ng-container>
</ion-content>

<ion-footer *ngIf="order" class="footer" role="contentinfo">
	<ng-container *ngIf="isOverviewPage">
		<app-tip
			(tip)="changeTip($event)"
			*ngIf="order && order.orderedArticles.length > 0 && venue"
			[order]="order"
			[venue]="venue"
			class="ion-no-padding"
		>
		</app-tip>
		<div class="sub-total" role="group" aria-labelledby="pricing-summary">
			<h3 id="pricing-summary" class="sr-only">Price Summary</h3>
			<p class="sub-total-title">Subtotal</p>
			<p class="sub-total-sum">{{ totalPriceBeforeDiscount }}</p>
		</div>
		<div class="sub-total" *ngIf="order?.preorder?.type === pt.FOOD_SPOT && companyDiscount">
			<p class="sub-total-title">Store Discount</p>
			<p class="sub-total-sum">{{ companyDiscount }}</p>
		</div>
		<div class="sub-total" *ngIf="order && order?.orderedArticles && order?.preorder?.type === pt.DELIVERY">
			<p class="sub-total-title">Delivery</p>
			<p class="sub-total-sum" *ngIf="order?.preorder">
				<ng-container *ngIf="!ou.isFreeDeliveryPromo(order)">
					+{{ numberToCurrency(order?.preorder?.deliveryFee ?? 0, order.currency) }}
				</ng-container>
				<ng-container *ngIf="ou.isFreeDeliveryPromo(order)">{{ numberToCurrency(0, order.currency) }} </ng-container>
			</p>
		</div>
		<div class="sub-total" *ngIf="tip">
			<p class="sub-total-title">Tip</p>
			<p class="sub-total-sum">{{ numberToCurrency(tip, order.currency) }}</p>
		</div>
		<ion-icon class="border-line" src="../../../assets/dean_and_david/border-line.svg" aria-hidden="true"></ion-icon>

		<div class="total">
			<p class="total-title">{{ 'order.total' | translate }}</p>
			<p class="total-sum">{{ totalPriceValue }}</p>
		</div>
	</ng-container>
	<div class="button-row" *ngIf="slots.length > 0 || order?.preorder?.type == pt.FOOD_SPOT">
		<ion-button
			(click)="onButtonClick()"
			(keydown.enter)="onButtonClick()"
			[disabled]="!isFormValid()"
			class="footer-btn"
			tabindex="0"
			[attr.aria-label]="isOverviewPage ? ('checkout_modal.pay' | translate) : ('checkout_modal.to_overview' | translate)"
			[attr.aria-describedby]="!isFormValid() ? 'button-disabled-reason' : null"
		>
			<h2 class="footer-btn-text" *ngIf="!loading" aria-hidden="true">
				<ng-container *ngIf="isOverviewPage">
					{{ 'checkout_modal.pay' | translate }}
				</ng-container>
				<ng-container *ngIf="!isOverviewPage">
					{{ 'checkout_modal.to_overview' | translate }}
				</ng-container>
			</h2>

			<ion-spinner
				*ngIf="loading"
				class="white center"
				name="crescent"
				aria-label="Processing payment..."
				role="status"
			></ion-spinner>
		</ion-button>

		<!-- Hidden description for disabled state -->
		<div id="button-disabled-reason" class="sr-only" *ngIf="!isFormValid()" role="status" aria-live="polite">
			Please complete all required fields to continue
		</div>
	</div>
</ion-footer>
